module.exports = __webpack_public_path__ + "fonts/s2-icons.983883f.eot";